export { default as Illustration } from './Illustration'
export { IllustrationSize } from './types'
